// These are used for sorting the categories that we get from the api
// NOT for showing a list of filters

export const CATEGORIES = [
    'FURNITURE',
    'SOFAS & ARMCHAIRS',
    'BABY & KIDS',
    'BEDS & MATTRESSES',
    'BATHROOM',
    'KITCHEN & APPLIANCES',
    'STORAGE & ORGANIZATION',
    'RUGS',
    'HOME TEXTILES',
    'HOME ELECTRONICS',
    'HOME DÉCOR',
    'COOKWARE & TABLEWARE',
]

export const SUBCATEGORIES = [
    'OTTOMANS',
    'SOFAS & SECTIONALS',
    'DRESSERS & STORAGE DRAWERS',
    'TABLES & DESKS',
    'BOOKCASES & SHELVING UNITS',
    'TV & MEDIA FURNITURE',
    'ARMOIRES & WARDROBES',
    'BABY FURNITURE',
    'KIDS FURNITURE',
    'CHAIRS',
    'ARMCHAIRS & CHAISES',
    'SIDEBOARDS, BUFFETS & SOFA TABLES',
    'DISPLAY & STORAGE CABINETS',
    'OUTDOOR FURNITURE',
    'BAR FURNITURE',
    'CAFÉ FURNITURE',
    'ROOM DIVIDERS',
    'KITCHEN ISLANDS & CARTS',
    'NURSERY FURNITURE',
    'SOFAS & ARMCHAIRS',
    'BEDS & MATTRESSES',
    'BEDS',
    'SLEEPER SOFAS',
    'SECTIONALS',
    'SOFA COVERS',
    'SOFA LEGS',
    'BABY',
    'CRIBS & CRIB MATTRESSES',
    'NURSING, FEEDING & EATING',
    'CHANGING, BATHING & POTTY',
    'BABY TEXTILES',
    'BABY TOYS',
    'KIDS',
    'KIDS MATTRESSES',
    'STUVA STORAGE SYSTEM',
    'KIDS STORAGE & ORGANIZATION',
    'KIDS TEXTILES',
    'KIDS KITCHENWARE AND TABLEWARE',
    'KIDS LIGHTING',
    'KIDS DECORATION & ACCESSORIES',
    'TOYS & PLAY',
    'SAFETY',
]
